import React from "react";
import LegalLayout from "../../components/LegalLayout";

const sectionStyle = { marginBottom: 24 };
const h1Style = {
	fontSize: 28,
	fontWeight: 700,
	margin: "0 0 24px",
	color: "#0f172a",
};
const h2Style = {
	fontSize: 18,
	fontWeight: 600,
	margin: "20px 0 10px",
	color: "#334155",
};
const pStyle = { margin: "0 0 12px" };

export default function LegalAviso() {
	return (
		<LegalLayout title="Aviso Legal">
			<h1 style={h1Style}>Aviso Legal</h1>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Titular del sitio web</h2>
				<p style={pStyle}>
					En cumplimiento de lo dispuesto en la Ley 34/2002, de Servicios de la
					Sociedad de la Información y Comercio Electrónico (LSSI-CE), se informa
					que el presente sitio web, Viajes Molones, es operado por:
				</p>

				<ul style={{ margin: "0 0 12px", paddingLeft: 24 }}>
					<li><strong>Entidad titular:</strong> Yowlu SL</li>
					<li><strong>NIF:</strong> B56552045</li>
					<li><strong>Domicilio social:</strong> Carrer Sepúlveda, 08015 Barcelona, España</li>
					<li><strong>Correo electrónico:</strong> hola@viajesmolones.com</li>
				</ul>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Objeto del sitio web</h2>
				<p style={pStyle}>
					Viajes Molones es una plataforma digital que ofrece guías de viaje,
					contenido informativo y productos digitales relacionados con la
					planificación de viajes.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Propiedad intelectual</h2>
				<p style={pStyle}>
					Todos los contenidos del sitio web, incluyendo textos, diseños,
					ilustraciones, imágenes, logotipos y materiales digitales, son
					propiedad del titular o cuentan con licencia de uso. Queda prohibida
					su reproducción, distribución o comunicación pública sin autorización
					expresa.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Responsabilidad</h2>
				<p style={pStyle}>
					El titular no garantiza la disponibilidad continua del sitio web ni
					la ausencia de errores en sus contenidos. El uso de la información
					disponible en el sitio web se realiza bajo la responsabilidad del
					usuario.
				</p>
				<p style={pStyle}>
					El sitio web puede incluir enlaces a páginas externas sobre las que
					el titular no tiene control y respecto de las cuales no asume
					responsabilidad alguna.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Reclamaciones</h2>
				<p style={pStyle}>
					Para cualquier consulta o reclamación puedes contactar en
					hola@viajesmolones.com.
				</p>

				<p style={pStyle}>
					La Comisión Europea pone a disposición de los consumidores una
					plataforma de resolución de litigios en línea:
				</p>

				<p style={pStyle}>
					<a
						href="https://ec.europa.eu/consumers/odr/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://ec.europa.eu/consumers/odr/
					</a>
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Legislación aplicable</h2>
				<p style={pStyle}>
					El presente Aviso Legal se rige por la legislación española.
				</p>
			</section>

			<p style={{ ...pStyle, fontSize: 14, color: "#64748b" }}>
				Última actualización: marzo 2026
			</p>
		</LegalLayout>
	);
}
